import { render } from "./ShopperCosts.vue?vue&type=template&id=089e49b8"
import script from "./ShopperCosts.vue?vue&type=script&lang=js"
export * from "./ShopperCosts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__